import { createFileRoute, Link, Outlet } from "@tanstack/react-router";

import Navigation from "$/lib/components/molecules/Navigation/Navigation";
import YearDropDown from "$/lib/components/organisms/YearDropDown/YearDropDown";
import { WarningAltIconNotif } from "$/lib/icons/WarningAltIconNotif";
import { ROUTES } from "$/lib/utils/constants/routes.constants";

import { useProfileProvider } from "../profile/-features/providers/ProfileProvider";

export const Route = createFileRoute(
  "/_user-layout/management/_management-layout",
)({
  component: ManagementLayout,
});

function ManagementLayout() {
  const { profileCompletion, setLastVisitedYearInTab } = useProfileProvider();
  const currentYear = new Date().getFullYear();
  const socialSecurityYear = currentYear - 2;
  const isSocialProfileMissing =
    profileCompletion?.socialInfoMissingYears.includes(socialSecurityYear) ??
    false;

  return (
    <div className="mt-6 screen850:mt-5 flex w-[93%] screen850:w-full mx-auto flex-col gap-7">
      {/* Mobile: Mon activité + Mes cotisations + Ma synthèse */}
      <div className="flex flex-col gap-4 screen850:hidden">
        {isSocialProfileMissing && (
          <Link
            to={ROUTES.PROFILE_SOCIALSECURITY}
            onClick={() =>
              setLastVisitedYearInTab("socialSecurity", socialSecurityYear)
            }
            className="flex items-center gap-2 rounded-xl border border-notif/50 bg-bgnotif px-3 py-2.5 hover:cursor-pointer"
          >
            <WarningAltIconNotif className="h-4 w-4 shrink-0" />
            <p className="text-[13px] font-medium text-textColor">
              Pour afficher les résultats, veuillez remplir les données de
              votre profil social {socialSecurityYear}
            </p>
          </Link>
        )}
        <Navigation
          links={[
            {
              label: "Mon activité",
              route: ROUTES.MANAGEMENT_MYBUSINESS,
            },
            {
              label: "Mes cotisations",
              route: ROUTES.MANAGEMENT_MYCONTRIBUTIONS,
            },
            {
              label: "Ma synthèse",
              route: ROUTES.MANAGEMENT_MYSUMMARY,
            },
          ]}
        ></Navigation>
      </div>
      {/* Desktop: all 4 tabs */}
      <div className="hidden screen850:block">
        <Navigation
          links={[
            {
              label: "Mon activité",
              route: ROUTES.MANAGEMENT_MYBUSINESS,
            },
            {
              label: "Mes cotisations sociales",
              route: ROUTES.MANAGEMENT_SOCIALCONTRIBUTIONS,
            },
            {
              label: "Mes impôts",
              route: ROUTES.MANAGEMENT_MYTAX,
            },
            {
              label: "Ma synthèse",
              route: ROUTES.MANAGEMENT_MYSUMMARY,
            },
          ]}
        >
          <YearDropDown />
        </Navigation>
      </div>
      <Outlet />
    </div>
  );
}
